type RuntimeEnv = {
  REACT_APP_AUTH0_DOMAIN?: string;
  REACT_APP_AUTH0_CLIENT_ID?: string;
  REACT_APP_AUTH0_AUDIENCE?: string;
  REACT_APP_API_BASE_URL?: string;
  REACT_APP_TIME_ZONE?: string;
};

declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
  }
}

const runtime: RuntimeEnv =
  (typeof window !== "undefined" && window.__ENV__) || {};

const read = (key: keyof RuntimeEnv): string | undefined =>
  runtime[key] || process.env[key];

export const env = {
  auth0Domain: read("REACT_APP_AUTH0_DOMAIN"),
  auth0ClientId: read("REACT_APP_AUTH0_CLIENT_ID"),
  auth0Audience: read("REACT_APP_AUTH0_AUDIENCE"),
  apiBaseUrl: read("REACT_APP_API_BASE_URL"),
  timeZone: read("REACT_APP_TIME_ZONE"),
};

export default env;
